export default __webpack_public_path__ + "static/media/6.a1c5cac8.jpg";